import React from "react";
import "./modal.scss";

const EmailTemplatePreviewModal = ({
  show,
  subject,
  bodyHtml,
  onClose,
  onAccept,
  acceptLabel = "Enviar correos",
  closeLabel = "Cancelar",
  showAccept = true,
  acceptDisabled = false,
  closeDisabled = false
}) => {
  if (!show) return null;

  return (
    <div className="noti_modal" id="email_template_preview_modal">
      <div className="noti_modal_cont">
        <div className="col-md-12">
          <br />
          <strong>Asunto: </strong>{subject}
          <br />
          <strong>Mensaje:</strong>
          <br />
          <div className="textAreaEmail">
            <div dangerouslySetInnerHTML={{ __html: bodyHtml }} />
          </div>
        </div>
        <div className="btn btn-group pull-right" style={{ marginTop: "1rem" }}>
          <button className="btn btn-default toggle-button" onClick={onClose} disabled={closeDisabled}>
            {closeLabel}
          </button>
          {showAccept ? (
            <button className="btn btn-default toggle-button" onClick={onAccept} disabled={acceptDisabled}>
              {acceptLabel}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default EmailTemplatePreviewModal;
